module.exports = __webpack_public_path__ + "static/media/MAINTENANCE.2a4fa97a.gif";